import { customSendPdf } from "@crescentParts/Services/CustomVmiBinsService";
import { ApiHandlerDiscreteParameter, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { GetVmiBinsApiParameter, SendVmiBinPdfApiParameter } from "@insite/client-framework/Services/VmiBinsService";
import { CallApi, chain } from "@insite/client-framework/Store/Pages/VmiLocationDetails/Handlers/SendVmiBinsPdf";
import {
    PdfBarcodeDataFieldOptions,
    PdfBarcodeFormatOptions,
    PdfLayoutOptions,
} from "@insite/client-framework/Types/PrintPdfModels";

interface Parameter extends HasOnSuccess {
    lineIds?: string[];
    layout: PdfLayoutOptions;
    barcodeFormat: PdfBarcodeFormatOptions;
    barcodeField: PdfBarcodeDataFieldOptions;
    displayFields?: string[];
    addOverlay?: boolean;
    baseParameter: GetVmiBinsApiParameter;
}

type HandlerType = ApiHandlerDiscreteParameter<Parameter, SendVmiBinPdfApiParameter, ServiceResult<{}>>;

export const CallApiExtended: HandlerType = async props => {
    props.apiResult = await customSendPdf(props.apiParameter);
};

replaceInChain(chain, CallApi, CallApiExtended);
